import { defineMessages } from 'react-intl';

export default defineMessages({
	rowLabel: {
		id: 'truemedCheckout.rowLabel',
		defaultMessage: 'HSA / FSA card',
		description: 'Label of the payment method row that lets a buyer pay with an HSA or FSA card',
	},
	rowDetail: {
		id: 'truemedCheckout.rowDetail',
		defaultMessage: 'with Truemed',
		description: 'Secondary text on the HSA / FSA payment method row naming the provider that processes it',
	},
	countryLabel: {
		id: 'truemedCheckout.countryLabel',
		defaultMessage: 'Country',
		description: 'Label of the read-only country field in the HSA/FSA payment method row',
	},
	countryValue: {
		id: 'truemedCheckout.countryValue',
		defaultMessage: 'United States',
		description: 'Value of the read-only country field; HSA/FSA payments are only available in the US',
	},
	redirectNotice: {
		id: 'truemedCheckout.redirectNotice',
		defaultMessage:
			"Another step will appear on Truemed to confirm eligibility with a short health questionnaire. You'll see your total, including tax, there.",
		description: 'Notice below the ZIP code field explaining the buyer is sent to Truemed to continue',
	},
	zipLabel: {
		id: 'truemedCheckout.zipLabel',
		defaultMessage: 'ZIP code',
		description: 'Label for the US ZIP code input used to calculate sales tax for an HSA/FSA purchase',
	},
	zipError: {
		id: 'truemedCheckout.zipError',
		defaultMessage: 'Enter a 5-digit ZIP code.',
		description: 'Inline error shown when the entered ZIP code is not a valid US ZIP code',
	},
	promoNotApplied: {
		id: 'truemedCheckout.promoNotApplied',
		defaultMessage: "Promo codes don't apply to HSA/FSA payments.",
		description:
			'Shown in the HSA/FSA panel when the buyer has a coupon or promotion that only applies to card and PayPal payments',
	},
	alreadySubscribed: {
		id: 'truemedCheckout.alreadySubscribed',
		defaultMessage: 'You already have a Calm subscription.',
		description: 'Error shown when the user tries to buy with HSA/FSA but already has a subscription',
	},
	unavailable: {
		id: 'truemedCheckout.unavailable',
		defaultMessage: 'Truemed is unavailable right now. Please try again or choose another payment method.',
		description:
			'Error shown when Truemed or the tax service cannot be reached, or HSA/FSA checkout is not enabled for the buyer',
	},
	invalid: {
		id: 'truemedCheckout.invalid',
		defaultMessage: "We couldn't use that ZIP code. Check it and try again.",
		description: 'Error shown when the server rejects the ZIP code',
	},
	unknown: {
		id: 'truemedCheckout.unknown',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'Generic error shown for an unexpected HSA/FSA checkout failure',
	},
});
